export const SITE_ORIGIN = "https://dropchance.app";

/** SEO hreflang alternates — keep in sync with public/index.html */
export const HREFLANG_ALTERNATES = [
  { lang: "en", href: `${SITE_ORIGIN}/` },
  { lang: "es", href: `${SITE_ORIGIN}/es/` },
  { lang: "ja", href: `${SITE_ORIGIN}/ja/` },
  { lang: "ko", href: `${SITE_ORIGIN}/ko/` },
  { lang: "zh", href: `${SITE_ORIGIN}/zh/` },
  { lang: "x-default", href: `${SITE_ORIGIN}/` },
];
